import { ChangeDetectionStrategy, Component, inject, signal, viewChild } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25EventQuotaInspectorComponent } from "./s25.event.quota.inspector.component";
import { EventFormSettingsModule } from "./event.form.settings.module";
import { S25ButtonComponent } from "../../../standalone/s25.button.component";
import { UserStore } from "../../../stores/user.store";

@TypeManagerDecorator("s25-ng-event-quota-admin")
@Component({
    selector: "s25-ng-event-quota-admin",
    imports: [S25EventQuotaInspectorComponent, EventFormSettingsModule, S25ButtonComponent],
    standalone: true,
    template: ` <h2 class="c-margin-bottom--single">Event Quotas</h2>
        <div>
            @if (userStore.isService25()) {
                <s25-ng-button class="c-margin-bottom--single" type="primary" (clicked)="onInspectClick()">{{
                    showInspector() ? "Hide inspector" : "Inspect Quotas"
                }}</s25-ng-button>
            }
            @if (showInspector()) {
                <s25-ng-event-quota-inspector></s25-ng-event-quota-inspector>
            }
            <s25-ng-event-quotas-list></s25-ng-event-quotas-list>
        </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class S25EventQuotaAdminComponent {
    readonly showInspector = signal(false);

    readonly userStore = inject(UserStore);

    onInspectClick(): void {
        this.showInspector.set(!this.showInspector());
    }
}
